export const selectLocationCountries = state => state.location.countries;
export const selectLocationStates = state => state.location.states;
export const selectLocationGeocodingAddresses = state => state.location.geocodingAddresses;
export const selectLocationAddresses = state => state.location.addresses;
export const selectLocationsaveGeocodingAddress = state => state.location.saveGeocodingAddressResult;
export const selectLocationCheckLocationName = state => state.location.checkLocationNameResult;
// get address list
export const locationAddresses = state => state.location.addresses;
export const locationDefaultAddressGeoCodingSource = state => state.location.defaultAddressGeoCodingSource;
export const locationGeocodingType = state => state.location.geocodingType;
export const locationEditable = state => state.location.editable;
export const locationCountries = state => state.location.countries;
export const locationExpose = state => state.location.expose;
export const expLocExpose = state => state.location.exposeExpLoc;
export const expLocEditable = state => state.location.editableExpLoc;
export const expectedLocations = state => state.location.expectedLocations;

// delete location
export const locationDeleteResult = state => state.location.status;
// add or edit location
export const locationAddOrEditResult = state => state.location.addOrEditStatus;
